<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="425"
    height="300"
    id="milestone-splittesting"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 380.2 227.6"
    role="presentation"
    aria-labelledby="launchofsplittesting"
  >
    <title id="launchofsplittesting">Launch of Split Testing</title>
    <defs>
      <mask id="mask" x="88.09" y="84.62" width="37" height="57" maskUnits="userSpaceOnUse">
        <g transform="translate(-0.7 -0.8)">
          <g id="path-79-outside-1">
            <rect class="cls-1" x="88.8" y="85.4" width="37" height="57" />
            <path
              d="M104.5,116.3l3-13.5h.2l3.1,10Zm7.2-27.9-4.2,2.3-4,2.5L92.8,137.4l8-4.8,2-8.4,9.8-5.6,1.9,6.3,8.1-4.7Z"
            />
          </g>
        </g>
      </mask>
      <mask id="mask-2" x="269.01" y="82.41" width="28" height="49" maskUnits="userSpaceOnUse">
        <g transform="translate(-0.7 -0.8)">
          <g id="path-148-outside-2">
            <rect class="cls-1" x="269.7" y="83.2" width="28" height="49" />
            <path
              d="M279.6,119.2v-8.5l4.4,2.5h.2a9.9,9.9,0,0,1,3.1,3,7.9,7.9,0,0,1,.9,3.8c0,1.4-.3,2.2-1.1,2.4a4.4,4.4,0,0,1-3.2-1Zm.2-13.9V97.1l2.8,1.6a10.3,10.3,0,0,1,3.6,3.2,5,5,0,0,1,1.1,3.7c0,1.3-.5,2.1-1.3,2.2s-2-.1-3.7-1.1Zm2.8-12.4-9.7-5.7-.2,34,11.3,6.5c3.6,2,6.4,2.8,8.3,2.2s3-2.6,3-5.9a16.6,16.6,0,0,0-1.2-5.5,15.2,15.2,0,0,0-4-5,2.8,2.8,0,0,0,3-1.1,6.9,6.9,0,0,0,1-3.8,14.8,14.8,0,0,0-3-8.8A34,34,0,0,0,282.6,92.9Z"
            />
          </g>
        </g>
      </mask>
    </defs>
    <g id="_2017_06_SplitTesting-2" data-name="2017_06_SplitTesting">
      <g id="Screen_A" data-name="Screen A">
        <g id="illustration_2" data-name="illustration 2">
          <g id="Square_1" data-name="Square 1">
            <path
              class="cls-1"
              d="M52.6,217.7c-.3.2-.4.4-.4.5a.7.7,0,0,0,.4.5l5.7,3.2a3.7,3.7,0,0,0,2.9,0l5.6-3.3c.3-.2.4-.4.4-.5a.7.7,0,0,0-.4-.5l-5.7-3.2a3.7,3.7,0,0,0-2.9,0Z"
              transform="translate(-0.7 -0.8)"
            />
            <path
              class="cls-2"
              d="M68.4,218.1a.9.9,0,0,0-.1-.5h0a2.8,2.8,0,0,0-.9-1l-5.7-3.2a4.1,4.1,0,0,0-4,0l-5.6,3.3a1.9,1.9,0,0,0-.9.9H51v2.9a1.7,1.7,0,0,0,1,1.6l5.7,3.1a4.6,4.6,0,0,0,2,.5,3.2,3.2,0,0,0,2.1-.6l5.6-3.3a2,2,0,0,0,1-1.4v-2.3Zm-7.3-3.7,5.7,3.2a.7.7,0,0,1,.4.5c0,.1-.1.3-.4.5l-5.6,3.3a3.7,3.7,0,0,1-2.9,0l-5.7-3.2a.7.7,0,0,1-.4-.5c0-.1.1-.3.4-.5l5.6-3.3A3.7,3.7,0,0,1,61.1,214.4Zm-1.9,10.9v-2.2H60v2.2Z"
              transform="translate(-0.7 -0.8)"
            />
            <rect class="cls-3" x="58.5" y="222.3" width="0.8" height="2.2" />
          </g>
          <g id="Circle_1" data-name="Circle 1">
            <path
              class="cls-2"
              d="M15,166.8h-.1a3.8,3.8,0,0,0-2.1-2.6,10.8,10.8,0,0,0-9.9,0,4.1,4.1,0,0,0-2.2,2.7h0v3.5a3.9,3.9,0,0,0,2.2,3.2,10.3,10.3,0,0,0,5,1.2,9.6,9.6,0,0,0,5-1.3,3.7,3.7,0,0,0,2.2-3.1v-3.6ZM3.5,169.6a2.8,2.8,0,0,1-1.6-2.2,2.6,2.6,0,0,1,1.6-2.2,8.9,8.9,0,0,1,4.4-1,9.7,9.7,0,0,1,4.3,1,2.8,2.8,0,0,1,1.6,2.2,2.6,2.6,0,0,1-1.6,2.2A9.5,9.5,0,0,1,3.5,169.6Zm-1.2.3H3v2.8H2.3Zm7.6,3.9V171h.7v2.8Z"
              transform="translate(-0.7 -0.8)"
            />
            <path
              class="cls-1"
              d="M13.8,167.4a2.8,2.8,0,0,0-1.6-2.2,9.7,9.7,0,0,0-4.3-1,8.9,8.9,0,0,0-4.4,1,2.6,2.6,0,0,0-1.6,2.2,2.8,2.8,0,0,0,1.6,2.2,9.5,9.5,0,0,0,8.7,0A2.6,2.6,0,0,0,13.8,167.4Z"
              transform="translate(-0.7 -0.8)"
            />
            <rect class="cls-3" x="9.2" y="170.2" width="0.7" height="2.8" />
            <rect class="cls-3" x="1.6" y="169.1" width="0.7" height="2.8" />
          </g>
          <g id="Screen">
            <path
              class="cls-1"
              d="M78.9,187.4l14.2,8.2a5.9,5.9,0,0,0,5.3.2l40.4-23.3a1.1,1.1,0,0,0,.7-.9c0-.4-.4-.9-1.1-1.3l-14.9-8.6Z"
              transform="translate(-0.7 -0.8)"
            />
            <polygon
              class="cls-1"
              points="40.9 194.3 40.9 177.3 40.9 134.8 34.4 130.7 34.4 190.3 34.4 190.2 40.9 194.3"
            />
            <path
              class="cls-1"
              d="M169,32.7a2.9,2.9,0,0,1,1.7-.6c-3.6-3.4-6.4-2.9-6.6-2.9a4.4,4.4,0,0,0-2.3.6l-1.3.8,5.8,3.6Z"
              transform="translate(-0.7 -0.8)"
            />
            <path
              class="cls-1"
              d="M41.6,201.5v-4.7l-6.5-4.1v4.7a3.7,3.7,0,0,0,1.1,3.1h.1a19.2,19.2,0,0,0,5.7,3.5,5.6,5.6,0,0,1-.4-2.3Z"
              transform="translate(-0.7 -0.8)"
            />
            <path
              class="cls-1"
              d="M46.7,103.3l1.6-.9-5.8-3.7-3,1.8a8.2,8.2,0,0,0-2.8,3l6.3,3.9A9.3,9.3,0,0,1,46.7,103.3Z"
              transform="translate(-0.7 -0.8)"
            />
            <polygon class="cls-1" points="164.2 34.2 158.4 30.5 43.2 97.1 49 100.7 164.2 34.2" />
            <path
              class="cls-1"
              d="M35.1,108.9v21h0l6.5,4.1V112.9a12,12,0,0,1,.8-4.2l-6.3-4A10.7,10.7,0,0,0,35.1,108.9Z"
              transform="translate(-0.7 -0.8)"
            />
            <path
              class="cls-3"
              d="M172.1,33.7a1.5,1.5,0,0,0-.9-.2,4.2,4.2,0,0,0-1.6.4L47.4,104.5c-2.4,1.4-4.4,5.2-4.4,8.4v65.2a3.1,3.1,0,0,0,1.1,2.7,2.9,2.9,0,0,0,2.9-.4l60.4-34.9v-4.1h1.4v3.3l59.8-34.5a10.5,10.5,0,0,0,4.7-8.2h.1V36.9A3.6,3.6,0,0,0,172.1,33.7ZM108.8,138.4h-1.4v-7.7h1.4Z"
              transform="translate(-0.7 -0.8)"
            />
            <path
              class="cls-2"
              d="M173.2,32.8c-4.9-5.8-9.1-4.9-9.3-4.9a6.3,6.3,0,0,0-2.9.8L38.8,99.3c-2.9,1.6-5.1,5.8-5.1,9.6v88.5a5.4,5.4,0,0,0,1.7,4.3c4,3.3,6.9,4.1,8.4,4.3a2.9,2.9,0,0,0,1.4.3,5.1,5.1,0,0,0,2.2-.7l25-14.4,19.9,11.5a8.1,8.1,0,0,0,3.7.9,5.8,5.8,0,0,0,3-.7l40.4-23.3a3.1,3.1,0,0,0,1.4-1.9,15.3,15.3,0,0,0,.2-6.1v-.2a3.1,3.1,0,0,0-1.8-2.4L125,160.8,169.7,135c2.9-1.6,5.1-5.8,5.1-9.6V36.9A5,5,0,0,0,173.2,32.8Zm-11.4-3a4.4,4.4,0,0,1,2.3-.6c.2,0,3-.5,6.6,2.9a2.9,2.9,0,0,0-1.7.6l-2.7,1.5-5.8-3.6Zm-2.7,1.5,5.8,3.7L49.6,101.6l-5.7-3.7ZM35.1,131.5l6.5,4.1v59.5l-6.5-4h0Zm1.2,69.1h-.1a3.7,3.7,0,0,1-1.1-3.1v-4.7l6.5,4.1v5a5.6,5.6,0,0,0,.4,2.3A19.2,19.2,0,0,1,36.3,200.6Zm5.3-87.7V134l-6.5-4.1h0v-21a10.7,10.7,0,0,1,1-4.2l6.3,4A12,12,0,0,0,41.6,112.9Zm-4.9-9.4a8.2,8.2,0,0,1,2.8-3l3-1.8,5.8,3.7-1.6.9a9.3,9.3,0,0,0-3.7,4.1Zm36.7,87.1-.4-.7,4.6-2.7.4.7Zm2.9-14.4,20.2-11.7.4.7L76.7,176.9Zm20.3,26.6h-.8V197h.8Zm41.8-32.5c.7.4,1.1.9,1.1,1.3a1.1,1.1,0,0,1-.7.9L98.4,195.8a5.9,5.9,0,0,1-5.3-.2l-14.2-8.2,44.6-25.7Zm-34.7-8v-3.7a4.9,4.9,0,0,1,2.1-4l3.7-2.1a2.1,2.1,0,0,1,2-.1,2.4,2.4,0,0,1,1,2.2v3.7a4.9,4.9,0,0,1-2.1,4l-3.7,2.1-1.1.3a1,1,0,0,1-.9-.2A2.4,2.4,0,0,1,103.7,162.3Zm15.6-10-.4-.7L139.1,140l.4.7ZM173.4,102h-.1a10.5,10.5,0,0,1-4.7,8.2l-59.8,34.5v-3.3h-1.4v4.1L47,180.4a2.9,2.9,0,0,1-2.9.4,3.1,3.1,0,0,1-1.1-2.7V112.9c0-3.2,2-7,4.4-8.4L169.6,33.9a4.2,4.2,0,0,1,1.6-.4,1.5,1.5,0,0,1,.9.2,3.6,3.6,0,0,1,1.3,3.2Z"
              transform="translate(-0.7 -0.8)"
            />
            <path
              class="cls-2"
              d="M105.8,162.7l3.7-2.1a2.9,2.9,0,0,0,1.2-2.3v-3.7c0-.3-.1-.5,0-.5h-.2l-3.7,2.1a2.9,2.9,0,0,0-1.2,2.3v3.7c0,.3.1.5,0,.5Z"
              transform="translate(-0.7 -0.8)"
            />
            <rect
              class="cls-3"
              x="117.6"
              y="145.8"
              width="23.3"
              height="0.8"
              transform="translate(-56.5 83.4) rotate(-30)"
            />
            <rect
              class="cls-3"
              x="75"
              y="170.3"
              width="23.3"
              height="0.8"
              transform="matrix(0.87, -0.5, 0.5, 0.87, -74.44, 65.36)"
            />
            <rect
              class="cls-3"
              x="72.9"
              y="188.5"
              width="5.3"
              height="0.8"
              transform="translate(-87 64.8) rotate(-30.9)"
            />
            <rect class="cls-3" x="95.1" y="196.2" width="0.8" height="5.8" />
            <path
              class="cls-3"
              d="M105.6,164.7l1.1-.3,3.7-2.1a4.9,4.9,0,0,0,2.1-4v-3.7a2.4,2.4,0,0,0-1-2.2,2.1,2.1,0,0,0-2,.1l-3.7,2.1a4.9,4.9,0,0,0-2.1,4v3.7a2.4,2.4,0,0,0,1,2.2A1,1,0,0,0,105.6,164.7Zm0-2.4v-3.7a2.9,2.9,0,0,1,1.2-2.3l3.7-2.1h.2c-.1,0,0,.2,0,.5v3.7a2.9,2.9,0,0,1-1.2,2.3l-3.7,2.1h-.2C105.7,162.8,105.6,162.6,105.6,162.3Z"
              transform="translate(-0.7 -0.8)"
            />
            <rect class="cls-2" x="106.7" y="129.9" width="1.4" height="7.7" />
          </g>
          <g id="Bubble">
            <g>
              <path
                class="cls-4"
                d="M46.9,130.1a1.3,1.3,0,0,0-1.2,0l-1.4.8a2.5,2.5,0,0,0-1.2,2.2v1.3a1.3,1.3,0,0,0,.6,1.2h1.2l1.4-.8a2.5,2.5,0,0,0,1.2-2.2v-1.3A1.3,1.3,0,0,0,46.9,130.1Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-4"
                d="M41.9,133a1.3,1.3,0,0,0-1.2,0l-1.4.8a2.5,2.5,0,0,0-1.2,2.2v1.3a1.3,1.3,0,0,0,.6,1.2h1.2l1.4-.8a2.8,2.8,0,0,0,1.2-2.3v-1.3A1.3,1.3,0,0,0,41.9,133Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-4"
                d="M37,135.8a1.3,1.3,0,0,0-1.2,0l-1.4.8a2.5,2.5,0,0,0-1.2,2.2v1.3a1.3,1.3,0,0,0,.6,1.2H35l1.4-.8a2.8,2.8,0,0,0,1.2-2.3V137A1.3,1.3,0,0,0,37,135.8Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-3"
                d="M49.4,122.2l-18,10.4a3.5,3.5,0,0,0-1.5,2.6v13.6a1.2,1.2,0,0,0,.2.7c.1.1.4,0,.7-.1l11.6-6.7h.9v.3a6.1,6.1,0,0,1-.2,2.7,9.2,9.2,0,0,0,2.4-4.6.7.7,0,0,1,.4-.6l2.8-1.6a3.5,3.5,0,0,0,1.5-2.6V122.8a1.2,1.2,0,0,0-.2-.7C50,122,49.7,122.1,49.4,122.2ZM37.6,138.3a2.8,2.8,0,0,1-1.2,2.3l-1.4.8H33.8a1.3,1.3,0,0,1-.6-1.2v-1.3a2.5,2.5,0,0,1,1.2-2.2l1.4-.8a1.3,1.3,0,0,1,1.2,0,1.3,1.3,0,0,1,.6,1.2Zm4.9-2.8a2.8,2.8,0,0,1-1.2,2.3l-1.4.8H38.7a1.3,1.3,0,0,1-.6-1.2V136a2.5,2.5,0,0,1,1.2-2.2l1.4-.8a1.3,1.3,0,0,1,1.2,0,1.3,1.3,0,0,1,.6,1.2Zm5-2.9a2.5,2.5,0,0,1-1.2,2.2l-1.4.8H43.7a1.3,1.3,0,0,1-.6-1.2v-1.3a2.5,2.5,0,0,1,1.2-2.2l1.4-.8a1.3,1.3,0,0,1,1.2,0,1.3,1.3,0,0,1,.6,1.2Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-2"
                d="M50.6,121.1l-.5-.2-3.3-2a2.1,2.1,0,0,0-1.7.2L27.2,129.4a4.6,4.6,0,0,0-2.1,3.7v13.5a1.8,1.8,0,0,0,.8,1.6l3.4,2,.2.2.8.2,1.2-.2,7.3-4.3,2.6,1.7v.2h.8a10.5,10.5,0,0,0,4.4-6.5l2.6-1.5a4.6,4.6,0,0,0,2.1-3.6V122.8A1.9,1.9,0,0,0,50.6,121.1Zm-5.9-1.2,3.2,1.9-.4.6-3.1-1.9ZM28.8,147.4l-3.1-1.9.3-.6,3.2,1.9Zm-2.3-15.8.3-.6,3.2,1.9-.4.6Zm23.8,4.8a3.5,3.5,0,0,1-1.5,2.6L46,140.6a.7.7,0,0,0-.4.6,9.2,9.2,0,0,1-2.4,4.6,6.1,6.1,0,0,0,.2-2.7v-.3h-.9l-11.6,6.7c-.3.1-.6.2-.7.1a1.2,1.2,0,0,1-.2-.7V135.2a3.5,3.5,0,0,1,1.5-2.6l18-10.4c.3-.1.6-.2.7-.1a1.2,1.2,0,0,1,.2.7Z"
                transform="translate(-0.7 -0.8)"
              />
              <rect
                class="cls-3"
                x="27.9"
                y="130.4"
                width="0.7"
                height="3.7"
                transform="matrix(0.52, -0.85, 0.85, 0.52, -100.14, 86.85)"
              />
              <rect
                class="cls-3"
                x="27.1"
                y="144.3"
                width="0.7"
                height="3.7"
                transform="translate(-112.4 92.8) rotate(-58.7)"
              />
              <rect
                class="cls-3"
                x="45.8"
                y="119.3"
                width="0.7"
                height="3.7"
                transform="translate(-82 96.8) rotate(-58.7)"
              />
            </g>
            <g id="Dots">
              <path
                class="cls-1"
                d="M44.2,133v1.5l1.4-.8a1.6,1.6,0,0,0,.6-1.2V131l-1.4.8A1.6,1.6,0,0,0,44.2,133Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-2"
                d="M46.9,130.1a1.3,1.3,0,0,0-1.2,0l-1.4.8a2.5,2.5,0,0,0-1.2,2.2v1.3a1.3,1.3,0,0,0,.6,1.2h1.2l1.4-.8a2.5,2.5,0,0,0,1.2-2.2v-1.3A1.3,1.3,0,0,0,46.9,130.1Zm-.7,1.1v1.3a1.6,1.6,0,0,1-.6,1.2l-1.4.8V133a1.6,1.6,0,0,1,.6-1.2l1.4-.8Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-1"
                d="M39.2,135.9v1.3a.1.1,0,0,0,.1.1l1.3-.7a1.6,1.6,0,0,0,.6-1.2v-1.5l-1.4.8A1.6,1.6,0,0,0,39.2,135.9Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-2"
                d="M41.9,133a1.3,1.3,0,0,0-1.2,0l-1.4.8a2.5,2.5,0,0,0-1.2,2.2v1.3a1.3,1.3,0,0,0,.6,1.2h1.2l1.4-.8a2.8,2.8,0,0,0,1.2-2.3v-1.3A1.3,1.3,0,0,0,41.9,133Zm-.7,1.1v1.3a1.6,1.6,0,0,1-.6,1.2l-1.3.7a.1.1,0,0,1-.1-.1v-1.3a1.6,1.6,0,0,1,.6-1.2l1.4-.8Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-1"
                d="M34.4,138.8v1.5l1.4-.8a1.6,1.6,0,0,0,.6-1.2v-1.5l-1.4.8A1.6,1.6,0,0,0,34.4,138.8Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-2"
                d="M37,135.8a1.3,1.3,0,0,0-1.2,0l-1.4.8a2.5,2.5,0,0,0-1.2,2.2v1.3a1.3,1.3,0,0,0,.6,1.2H35l1.4-.8a2.8,2.8,0,0,0,1.2-2.3V137A1.3,1.3,0,0,0,37,135.8Zm-.6,1.2v1.3a1.6,1.6,0,0,1-.6,1.2l-1.4.8v-1.5a1.6,1.6,0,0,1,.6-1.2l1.4-.8Z"
                transform="translate(-0.7 -0.8)"
              />
            </g>
          </g>
          <g id="Magnifying_Glass" data-name="Magnifying Glass">
            <g>
              <path
                class="cls-1"
                d="M141,69.3c2.2-2.1,2.9-5.7,1.8-10-1.6-6.9-7.2-14.1-13.7-18.4a12.7,12.7,0,0,1,1.3,1.9,11.9,11.9,0,0,0-2.2-1.2,13.8,13.8,0,0,0-6.8-4.8,6.3,6.3,0,0,0-1.9-.3,3.5,3.5,0,0,0-2.5.9c-1,.9-1.2,2.5-.8,4.4a14.7,14.7,0,0,0,7.2,8.9,17.5,17.5,0,0,1-1.9-3.9c-.3-2.1,0-3.7,1.1-4.8a4.7,4.7,0,0,1,4.7-.7,8.8,8.8,0,0,1,2,.9l1,1.7,1.1.8a14.2,14.2,0,0,1,.5,1.6c.6,2.3.2,4.3-1.1,5.5a4.4,4.4,0,0,1-3.2,1.2H127l-1.5-1.4h.1c1.9.6,3.5.4,4.4-.6s1.2-2.5.8-4.4a12,12,0,0,0-1.3-3.1,6.4,6.4,0,0,0-2.5-1.2,3.7,3.7,0,0,0-3.8.5,3.9,3.9,0,0,0-.7,3.8,11.8,11.8,0,0,0,3.7,5.8l-.9-.2-.6-.2.3.3.3.3c-4.5-1.3-9-6.1-10.1-10.6a5.7,5.7,0,0,1,.6-4.9,7.6,7.6,0,0,0-3.7,1.8l-.6.7a13.6,13.6,0,0,0,.2,6.6A32.1,32.1,0,0,0,118.8,59l1,1.1,1.2,1.3a32.5,32.5,0,0,0,12.7,7.9,15.4,15.4,0,0,0,6.6.5Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-3"
                d="M135,74.1c5.9,1.7,10.8,1.1,13.8-1.9s4-7.8,2.5-13.7c-3-12.6-15.6-25.7-28-29.4a26.5,26.5,0,0,0-6-.9,10.7,10.7,0,0,0-7.8,2.8c-3.1,2.9-4,7.8-2.5,13.7C110,57.2,122.6,70.4,135,74.1Zm13-17.4c1.2,5.1.4,9.4-2.4,12.1a9.7,9.7,0,0,1-7.1,2.6,19.2,19.2,0,0,1-5.1-.8c-10.2-3-20.5-13.8-23-24.1-1.2-5.1-.4-9.4,2.4-12.1s7.1-3.3,12.2-1.8C135.2,35.6,145.5,46.4,148,56.7Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-2"
                d="M152.6,58.2c-3.2-13-16.2-26.6-29-30.4-6.1-1.8-11.3-1.2-14.8,1.8h0l-3,2.9a12.6,12.6,0,0,0-3.6,9.1l-41.1-12h-.4A1.6,1.6,0,0,0,59,30a3.7,3.7,0,0,0-1,3.1l.7,3.1a1.4,1.4,0,0,0,.8,1l.5.3,43.7,12.7C107.9,62.4,120,74.4,131.9,78a21.7,21.7,0,0,0,6.4,1c3.5,0,6.4-1,8.3-3l.2-.2h.1l1.3-1.3,1.5-1.1C153.1,70,154.2,64.6,152.6,58.2ZM109.5,31a10.7,10.7,0,0,1,7.8-2.8,26.5,26.5,0,0,1,6,.9c12.4,3.7,25,16.8,28,29.4,1.5,5.9.6,10.8-2.5,13.7s-7.9,3.6-13.8,1.9c-12.4-3.7-25-16.9-28-29.4C105.5,38.8,106.4,33.9,109.5,31Zm-4.6,12.8h0l.8,3.2v.5L62.5,34.9a4,4,0,0,0,0-1.1l-.7-2.6Zm-.4,5.3s.6-.1.9-1l1,.4a2.3,2.3,0,0,1-1.9,1.7Zm22.3,22.1.7.8-2.3,2.2-.8-.8Zm5.1,2.3.7.8-2.3,2.2-.8-.8Zm-72-42.6.3-.2h0L61,34a2.2,2.2,0,0,1-.6,1.8l-.3.2h0l-.8-3.2A2.8,2.8,0,0,1,59.9,30.9Zm45.5,5.7.7.8-2.3,2.2-.8-.8Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-2"
                d="M125,32.6c-5.1-1.5-9.4-.8-12.2,1.8s-3.6,7-2.4,12.1c2.5,10.3,12.8,21.1,23,24.1a19.2,19.2,0,0,0,5.1.8,9.7,9.7,0,0,0,7.1-2.6c2.8-2.7,3.6-7,2.4-12.1C145.5,46.4,135.2,35.6,125,32.6Zm8.7,36.7A32.5,32.5,0,0,1,121,61.4l-1.2-1.3-1-1.1a32.1,32.1,0,0,1-7.1-12.8,13.6,13.6,0,0,1-.2-6.6l.6-.7a7.6,7.6,0,0,1,3.7-1.8,5.7,5.7,0,0,0-.6,4.9c1.1,4.5,5.6,9.3,10.1,10.6l-.3-.3-.3-.3-.4-.2-.9-1.1a14.7,14.7,0,0,1-7.2-8.9c-.4-1.9-.2-3.5.8-4.4a3.5,3.5,0,0,1,2.5-.9,6.3,6.3,0,0,1,1.9.3,13.8,13.8,0,0,1,6.8,4.8,11.9,11.9,0,0,1,2.2,1.2,12.7,12.7,0,0,0-1.3-1.9c6.5,4.3,12.1,11.5,13.7,18.4,1.1,4.3.4,7.9-1.8,10l-.7.5A15.4,15.4,0,0,1,133.7,69.3Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-2"
                d="M129.5,43.5a12,12,0,0,1,1.3,3.1c.4,1.9.2,3.5-.8,4.4s-2.5,1.2-4.4.6h-.1L127,53h.6a4.4,4.4,0,0,0,3.2-1.2c1.3-1.2,1.7-3.2,1.1-5.5a14.2,14.2,0,0,0-.5-1.6l-1.1-.8a.3.3,0,0,1,.1.2Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-3"
                d="M126.2,52.4a11.8,11.8,0,0,1-3.7-5.8,3.9,3.9,0,0,1,.7-3.8,3.7,3.7,0,0,1,3.8-.5,6.4,6.4,0,0,1,2.5,1.2l.9.6a.3.3,0,0,0-.1-.2l-1-1.7a8.8,8.8,0,0,0-2-.9,4.7,4.7,0,0,0-4.7.7c-1.1,1.1-1.4,2.7-1.1,4.8a17.5,17.5,0,0,0,1.9,3.9l.9,1.1.4.2.6.2Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-1"
                d="M61.8,31.2l.7,2.6a4,4,0,0,1,0,1.1l43.2,12.7v-.5l-.8-3.2h0Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-3"
                d="M59.3,32.7l.8,3.2h0l.3-.2A2.2,2.2,0,0,0,61,34l-.8-3.2h0l-.3.2A2.8,2.8,0,0,0,59.3,32.7Z"
                transform="translate(-0.7 -0.8)"
              />
              <path
                class="cls-3"
                d="M106.4,48.5l-1-.4c-.3.9-.9,1-.9,1v1.1A2.3,2.3,0,0,0,106.4,48.5Z"
                transform="translate(-0.7 -0.8)"
              />
              <rect
                class="cls-3"
                x="103"
                y="37.6"
                width="3.2"
                height="1.1"
                transform="translate(1.9 81.9) rotate(-43.6)"
              />
              <rect
                class="cls-3"
                x="129.5"
                y="74.5"
                width="3.2"
                height="1.1"
                transform="translate(-16.3 110.3) rotate(-43.6)"
              />
              <rect
                class="cls-3"
                x="124.4"
                y="72.1"
                width="3.2"
                height="1.1"
                transform="translate(-16.1 106.2) rotate(-43.6)"
              />
            </g>
            <g id="Lines">
              <g id="XMLID_113" data-name="XMLID 113">
                <g id="XMLID_114" data-name="XMLID 114">
                  <g id="XMLID_115" data-name="XMLID 115">
                    <path
                      id="XMLID_116"
                      data-name="XMLID 116"
                      class="cls-2"
                      d="M109.9,18.9l-1.3.4,1.6,5.5,1.4-.4Z"
                      transform="translate(-0.7 -0.8)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_109" data-name="XMLID 109">
                <g id="XMLID_110" data-name="XMLID 110">
                  <g id="XMLID_111" data-name="XMLID 111">
                    <path
                      id="XMLID_112"
                      data-name="XMLID 112"
                      class="cls-2"
                      d="M102.8,22.4l-1,.9,3.9,4.2,1-1Z"
                      transform="translate(-0.7 -0.8)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_105" data-name="XMLID 105">
                <g id="XMLID_106" data-name="XMLID 106">
                  <g id="XMLID_107" data-name="XMLID 107">
                    <path
                      id="XMLID_108"
                      data-name="XMLID 108"
                      class="cls-2"
                      d="M116,18.2l-1,5.6,1.4.2.9-5.6Z"
                      transform="translate(-0.7 -0.8)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="A">
            <g id="Group_2" data-name="Group 2">
              <g id="Group_3" data-name="Group 3">
                <g id="Vector">
                  <path
                    class="cls-1"
                    d="M104.5,116.3l3-13.5h.2l3.1,10Zm7.2-27.9-4.2,2.3-4,2.5L92.8,137.4l8-4.8,2-8.4,9.8-5.6,1.9,6.3,8.1-4.7Z"
                    transform="translate(-0.7 -0.8)"
                  />
                  <g class="cls-5">
                    <path
                      class="cls-6"
                      d="M104.5,116.3l3-13.5h.2l3.1,10Zm7.2-27.9-4.2,2.3-4,2.5L92.8,137.4l8-4.8,2-8.4,9.8-5.6,1.9,6.3,8.1-4.7Z"
                      transform="translate(-0.7 -0.8)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g id="Screen_B" data-name="Screen B">
        <g id="Square">
          <g id="XMLID_2752" data-name="XMLID 2752">
            <g id="XMLID_2777" data-name="XMLID 2777">
              <g id="XMLID_2783" data-name="XMLID 2783">
                <g id="XMLID_2784" data-name="XMLID 2784">
                  <path
                    id="XMLID_2785"
                    data-name="XMLID 2785"
                    class="cls-2"
                    d="M259.9,210.7h-3l-3.3-1.9a4.3,4.3,0,0,0-3.5,0l-3.1,1.8h-3.2V213a1,1,0,0,0,.7,1l5.7,3.2a4.3,4.3,0,0,0,3.5,0l5.6-3.3c.4-.3.7-.6.7-.9v-2.3Z"
                    transform="translate(-0.7 -0.8)"
                  />
                </g>
              </g>
              <g id="XMLID_2778" data-name="XMLID 2778">
                <g id="XMLID_2779" data-name="XMLID 2779">
                  <path
                    id="XMLID_2780"
                    data-name="XMLID 2780"
                    class="cls-2"
                    d="M251.8,218.3a4.6,4.6,0,0,1-2-.5l-5.7-3.2a1.7,1.7,0,0,1-1-1.6v-2.9h3.6l3-1.8a4.3,4.3,0,0,1,4.1,0L257,210h3.4v2.9a2,2,0,0,1-1,1.4l-5.6,3.3A2.7,2.7,0,0,1,251.8,218.3Zm-7.5-7v1.9a.7.7,0,0,0,.4.6l5.7,3.2a3.9,3.9,0,0,0,3,0l5.6-3.3a.7.7,0,0,0,.4-.5v-1.8h-2.8l-3.3-1.9a3.9,3.9,0,0,0-3,0l-3.2,1.9h-2.8Z"
                    transform="translate(-0.7 -0.8)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_2767" data-name="XMLID 2767">
              <g id="XMLID_2773" data-name="XMLID 2773">
                <g id="XMLID_2774" data-name="XMLID 2774">
                  <path
                    id="XMLID_2775"
                    data-name="XMLID 2775"
                    class="cls-3"
                    d="M250.1,206.5l-5.6,3.3a1.1,1.1,0,0,0,0,2l5.7,3.2a4,4,0,0,0,3.4,0l5.6-3.3a1.1,1.1,0,0,0,0-2l-5.7-3.2A3.4,3.4,0,0,0,250.1,206.5Z"
                    transform="translate(-0.7 -0.8)"
                  />
                </g>
              </g>
              <g id="XMLID_2768" data-name="XMLID 2768">
                <g id="XMLID_2769" data-name="XMLID 2769">
                  <path
                    id="XMLID_2770"
                    data-name="XMLID 2770"
                    class="cls-2"
                    d="M251.8,216a3.8,3.8,0,0,1-1.9-.5l-5.7-3.2a1.9,1.9,0,0,1-1-1.5,1.7,1.7,0,0,1,1-1.5l5.6-3.3a4.1,4.1,0,0,1,4,0l5.7,3.2a1.9,1.9,0,0,1,1,1.5,1.7,1.7,0,0,1-1,1.5l-5.6,3.3A4.6,4.6,0,0,1,251.8,216Zm-1.5-9.1-5.6,3.3c-.3.2-.4.4-.4.5a.7.7,0,0,0,.4.5l5.7,3.2a3.7,3.7,0,0,0,2.9,0l5.6-3.3c.3-.2.4-.4.4-.5a.7.7,0,0,0-.4-.5l-5.7-3.2A3.7,3.7,0,0,0,250.3,206.9Z"
                    transform="translate(-0.7 -0.8)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_2757" data-name="XMLID 2757">
              <g id="XMLID_2763" data-name="XMLID 2763">
                <g id="XMLID_2764" data-name="XMLID 2764">
                  <path
                    id="XMLID_2765"
                    data-name="XMLID 2765"
                    class="cls-1"
                    d="M250.1,206.5l-5.6,3.3a1.1,1.1,0,0,0,0,2l5.7,3.2a4,4,0,0,0,3.4,0l5.6-3.3a1.1,1.1,0,0,0,0-2l-5.7-3.2A3.4,3.4,0,0,0,250.1,206.5Z"
                    transform="translate(-0.7 -0.8)"
                  />
                </g>
              </g>
              <g id="XMLID_2758" data-name="XMLID 2758">
                <g id="XMLID_2759" data-name="XMLID 2759">
                  <path
                    id="XMLID_2760"
                    data-name="XMLID 2760"
                    class="cls-2"
                    d="M251.8,216a3.8,3.8,0,0,1-1.9-.5l-5.7-3.2a1.9,1.9,0,0,1-1-1.5,1.7,1.7,0,0,1,1-1.5l5.6-3.3a4.1,4.1,0,0,1,4,0l5.7,3.2a1.9,1.9,0,0,1,1,1.5,1.7,1.7,0,0,1-1,1.5l-5.6,3.3A4.6,4.6,0,0,1,251.8,216Zm-1.5-9.1-5.6,3.3c-.3.2-.4.4-.4.5a.7.7,0,0,0,.4.5l5.7,3.2a3.7,3.7,0,0,0,2.9,0l5.6-3.3c.3-.2.4-.4.4-.5a.7.7,0,0,0-.4-.5l-5.7-3.2A3.7,3.7,0,0,0,250.3,206.9Z"
                    transform="translate(-0.7 -0.8)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_2753" data-name="XMLID 2753">
              <g id="XMLID_2754" data-name="XMLID 2754">
                <g id="XMLID_2755" data-name="XMLID 2755">
                  <path
                    id="XMLID_2756"
                    data-name="XMLID 2756"
                    class="cls-3"
                    d="M252.2,215.6h-.8v2.2h.8Z"
                    transform="translate(-0.7 -0.8)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="Circle_3" data-name="Circle 3">
          <g id="XMLID_2586" data-name="XMLID 2586">
            <g id="XMLID_2600" data-name="XMLID 2600">
              <g id="XMLID_2605" data-name="XMLID 2605">
                <path
                  id="XMLID_2606"
                  data-name="XMLID 2606"
                  class="cls-2"
                  d="M380.3,140.7h0v-2.6h-2.6a10.4,10.4,0,0,0-8.1,0H367v2.6a3.2,3.2,0,0,0,1.9,3,10.2,10.2,0,0,0,9.3,0C379.8,142.9,380.5,141.8,380.3,140.7Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
              <g id="XMLID_2601" data-name="XMLID 2601">
                <path
                  id="XMLID_2602"
                  data-name="XMLID 2602"
                  class="cls-2"
                  d="M373.8,145.4a10.3,10.3,0,0,1-5-1.2,3.9,3.9,0,0,1-2.2-3.2v-3.5h2.9a11.1,11.1,0,0,1,8.4,0h2.9V141a3.7,3.7,0,0,1-2.2,3.1A9,9,0,0,1,373.8,145.4Zm-6-5.2h.1v.5c-.1.9.4,1.7,1.6,2.4a9.5,9.5,0,0,0,8.7,0c1.1-.7,1.7-1.5,1.6-2.4v-.5h.1v-1.6h-2.2a10,10,0,0,0-7.6,0h-2.2v1.6Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2593" data-name="XMLID 2593">
              <g id="XMLID_2598" data-name="XMLID 2598">
                <path
                  id="XMLID_2599"
                  data-name="XMLID 2599"
                  class="cls-1"
                  d="M378.4,135.3c2.6,1.5,2.6,3.9,0,5.4a10.2,10.2,0,0,1-9.3,0c-2.6-1.5-2.6-3.9,0-5.4A10.8,10.8,0,0,1,378.4,135.3Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
              <g id="XMLID_2594" data-name="XMLID 2594">
                <path
                  id="XMLID_2595"
                  data-name="XMLID 2595"
                  class="cls-2"
                  d="M373.8,142.4a10.3,10.3,0,0,1-5-1.2,3.4,3.4,0,0,1,0-6.4,10.8,10.8,0,0,1,9.9,0,3.4,3.4,0,0,1,0,6.4A9.9,9.9,0,0,1,373.8,142.4Zm0-7.6a8.9,8.9,0,0,0-4.4,1,2.6,2.6,0,0,0-1.6,2.2,2.8,2.8,0,0,0,1.6,2.2,9.5,9.5,0,0,0,8.7,0,2.6,2.6,0,0,0,1.6-2.2,2.8,2.8,0,0,0-1.6-2.2A9.7,9.7,0,0,0,373.8,134.8Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2590" data-name="XMLID 2590">
              <g id="XMLID_2591" data-name="XMLID 2591">
                <path
                  id="XMLID_2592"
                  data-name="XMLID 2592"
                  class="cls-3"
                  d="M376.5,141.5h-.7v2.8h.7Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2587" data-name="XMLID 2587">
              <g id="XMLID_2588" data-name="XMLID 2588">
                <path
                  id="XMLID_2589"
                  data-name="XMLID 2589"
                  class="cls-3"
                  d="M368.9,140.5h-.7v2.8h.7Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Circle_2" data-name="Circle 2">
          <g id="XMLID_2543" data-name="XMLID 2543">
            <g id="XMLID_2557" data-name="XMLID 2557">
              <g id="XMLID_2562" data-name="XMLID 2562">
                <path
                  id="XMLID_2563"
                  data-name="XMLID 2563"
                  class="cls-2"
                  d="M329.9,220.3v-2.6h-2.6a10.4,10.4,0,0,0-8.1,0h-2.6v2.6a3.2,3.2,0,0,0,1.9,3,10.2,10.2,0,0,0,9.3,0C329.4,222.5,330,221.4,329.9,220.3Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
              <g id="XMLID_2558" data-name="XMLID 2558">
                <path
                  id="XMLID_2559"
                  data-name="XMLID 2559"
                  class="cls-2"
                  d="M323.3,225a10.3,10.3,0,0,1-5-1.2,3.9,3.9,0,0,1-2.2-3.2v-3.5H319a11.1,11.1,0,0,1,8.4,0h2.9v3.6a3.7,3.7,0,0,1-2.2,3.1A8.8,8.8,0,0,1,323.3,225Zm-6-5.2h.1v.5c-.1.9.4,1.7,1.6,2.4a9.5,9.5,0,0,0,8.7,0c1.1-.7,1.7-1.5,1.6-2.4v-.5h.1v-1.6H327a10,10,0,0,0-7.6,0h-2.2v1.6Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2550" data-name="XMLID 2550">
              <g id="XMLID_2555" data-name="XMLID 2555">
                <path
                  id="XMLID_2556"
                  data-name="XMLID 2556"
                  class="cls-1"
                  d="M328,214.9c2.6,1.5,2.6,3.9,0,5.4a10.2,10.2,0,0,1-9.3,0c-2.6-1.5-2.6-3.9,0-5.4A10.2,10.2,0,0,1,328,214.9Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
              <g id="XMLID_2551" data-name="XMLID 2551">
                <path
                  id="XMLID_2552"
                  data-name="XMLID 2552"
                  class="cls-2"
                  d="M323.3,222a10.3,10.3,0,0,1-5-1.2,3.4,3.4,0,0,1,0-6.4,10.8,10.8,0,0,1,9.9,0,3.4,3.4,0,0,1,0,6.4A9.6,9.6,0,0,1,323.3,222Zm0-7.6a8.9,8.9,0,0,0-4.4,1,2.6,2.6,0,0,0-1.6,2.2,2.8,2.8,0,0,0,1.6,2.2,9.5,9.5,0,0,0,8.7,0,2.6,2.6,0,0,0,1.6-2.2,2.8,2.8,0,0,0-1.6-2.2A8.3,8.3,0,0,0,323.3,214.4Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2547" data-name="XMLID 2547">
              <g id="XMLID_2548" data-name="XMLID 2548">
                <path
                  id="XMLID_2549"
                  data-name="XMLID 2549"
                  class="cls-3"
                  d="M326.1,221.1h-.7v2.8h.7Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2544" data-name="XMLID 2544">
              <g id="XMLID_2545" data-name="XMLID 2545">
                <path
                  id="XMLID_2546"
                  data-name="XMLID 2546"
                  class="cls-3"
                  d="M318.4,220h-.7v2.8h.7Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Circle_1-2" data-name="Circle 1">
          <g id="XMLID_2500" data-name="XMLID 2500">
            <g id="XMLID_2514" data-name="XMLID 2514">
              <g id="XMLID_2519" data-name="XMLID 2519">
                <path
                  id="XMLID_2520"
                  data-name="XMLID 2520"
                  class="cls-2"
                  d="M301.4,42.8h0V40.2a.1.1,0,0,0-.1-.1h-2.4a10.4,10.4,0,0,0-8.1,0h-2.5a.1.1,0,0,0-.1.1v2.6a3.2,3.2,0,0,0,1.9,3,10.2,10.2,0,0,0,9.3,0C300.9,44.9,301.5,43.8,301.4,42.8Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
              <g id="XMLID_2515" data-name="XMLID 2515">
                <path
                  id="XMLID_2516"
                  data-name="XMLID 2516"
                  class="cls-2"
                  d="M294.8,47.4a10.3,10.3,0,0,1-5-1.2,3.9,3.9,0,0,1-2.2-3.2V39.5h2.9a11.1,11.1,0,0,1,8.4,0h2.9V43a3.7,3.7,0,0,1-2.2,3.1A8.8,8.8,0,0,1,294.8,47.4Zm-6-5.1h.1v.5c-.1.9.4,1.7,1.6,2.4a9.5,9.5,0,0,0,8.7,0c1.1-.7,1.7-1.5,1.6-2.4v-.5h.1V40.7h-2.2a10,10,0,0,0-7.6,0h-2.2v1.6Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2507" data-name="XMLID 2507">
              <g id="XMLID_2512" data-name="XMLID 2512">
                <path
                  id="XMLID_2513"
                  data-name="XMLID 2513"
                  class="cls-1"
                  d="M299.5,37.4c2.6,1.5,2.6,3.9,0,5.4a10.2,10.2,0,0,1-9.3,0c-2.6-1.5-2.6-3.9,0-5.4A10.2,10.2,0,0,1,299.5,37.4Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
              <g id="XMLID_2508" data-name="XMLID 2508">
                <path
                  id="XMLID_2509"
                  data-name="XMLID 2509"
                  class="cls-2"
                  d="M294.8,44.5a10.3,10.3,0,0,1-5-1.2,3.9,3.9,0,0,1-2.2-3.2,3.9,3.9,0,0,1,2.2-3.2,10.8,10.8,0,0,1,9.9,0,3.9,3.9,0,0,1,2.2,3.2,3.9,3.9,0,0,1-2.2,3.2A9.6,9.6,0,0,1,294.8,44.5Zm0-7.6a8.9,8.9,0,0,0-4.4,1,2.6,2.6,0,0,0-1.6,2.2,2.8,2.8,0,0,0,1.6,2.2,9.5,9.5,0,0,0,8.7,0,2.6,2.6,0,0,0,1.6-2.2,2.8,2.8,0,0,0-1.6-2.2A8.3,8.3,0,0,0,294.8,36.9Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2504" data-name="XMLID 2504">
              <g id="XMLID_2505" data-name="XMLID 2505">
                <path
                  id="XMLID_2506"
                  data-name="XMLID 2506"
                  class="cls-3"
                  d="M297.6,43.6h-.7v2.8h.7Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
            <g id="XMLID_2501" data-name="XMLID 2501">
              <g id="XMLID_2502" data-name="XMLID 2502">
                <path
                  id="XMLID_2503"
                  data-name="XMLID 2503"
                  class="cls-3"
                  d="M289.9,42.5h-.7v2.8h.7Z"
                  transform="translate(-0.7 -0.8)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Screen-2" data-name="Screen">
          <path
            class="cls-1"
            d="M250.3,170.2c-.7.4-1.1.9-1.1,1.3s.4.7.7.9l40.4,23.3c1.3.8,3.7.6,5.3-.2l14.2-8.2-44.6-25.7Z"
            transform="translate(-0.7 -0.8)"
          />
          <polygon
            class="cls-1"
            points="346.4 194.1 352.8 190.1 352.8 130.5 346.4 134.6 346.4 194.1"
          />
          <polygon class="cls-1" points="338.2 100.6 343.9 97 228.8 30.4 223 34 338.2 100.6" />
          <path
            class="cls-1"
            d="M346.2,108.5a11.1,11.1,0,0,1,.9,4.3v20.9l6.4-4V108.8a10.4,10.4,0,0,0-1-4.2Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-1"
            d="M347.1,201.3a6.1,6.1,0,0,1-.6,2.8,19.4,19.4,0,0,0,5.8-3.5h.1a3.7,3.7,0,0,0,1.1-3.1v-4.8l-6.4,4Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-1"
            d="M342,103.2a10.1,10.1,0,0,1,3.6,4l6.3-3.9a8.7,8.7,0,0,0-2.8-2.9L346,98.6l-5.7,3.6Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-1"
            d="M222.3,34.1l5.8-3.6-1.2-.7a4,4,0,0,0-2.3-.6c-.2,0-3-.5-6.5,2.8a5.2,5.2,0,0,1,1.6.6Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-2"
            d="M349.9,99.1,227.6,28.5a6.7,6.7,0,0,0-2.9-.8c-.2,0-4.7-.8-9.6,5.2l-.2.3h0a6.4,6.4,0,0,0-1,3.6v89c0,.2.1.3.1.4a7.4,7.4,0,0,0,.5,2.5c.9,2.6,2.6,5.1,4.5,6.2l44.7,25.8-14.2,8.2a3.6,3.6,0,0,0-1.8,2.3.4.4,0,0,1-.1.3,20,20,0,0,0,.2,6.1c.1.1.5,1.4,1.4,1.9l40.4,23.3a5.8,5.8,0,0,0,3,.7,8.1,8.1,0,0,0,3.7-.9l20-11.6,25,14.5a3.8,3.8,0,0,0,2.2.7l1-.2c1.3-.1,4.4-.8,8.7-4.5h.1a5,5,0,0,0,1.7-4.2V108.7C355,105,352.7,100.7,349.9,99.1Zm-.8,1.3a8.7,8.7,0,0,1,2.8,2.9l-6.3,3.9a10.1,10.1,0,0,0-3.6-4l-1.7-1,5.7-3.6Zm-4.5-2.6-5.7,3.6L223.7,34.9l5.8-3.7Zm-120-68.6a4,4,0,0,1,2.3.6l1.2.7-5.8,3.6-2.6-1.5a5.2,5.2,0,0,0-1.6-.6C221.6,28.7,224.4,29.2,224.6,29.2Zm24.5,111.4.4-.7,20.2,11.7-.4.7Zm43.7,62.1H292v-5.8h.8Zm2.8-7.2c-1.6.8-4,1-5.3.2l-40.4-23.3c-.3-.2-.7-.5-.7-.9s.4-.9,1.1-1.3l14.9-8.6,44.6,25.7Zm-12.7-41a4.9,4.9,0,0,1,2.1,4v3.7a2.6,2.6,0,0,1-1,2.2,2,2,0,0,1-1,.2,2,2,0,0,1-1.1-.3l-3.7-2.1a4.9,4.9,0,0,1-2.1-4v-3.7a2.4,2.4,0,0,1,1.1-2.2,2.1,2.1,0,0,1,2,.1Zm8.8,10.7.4-.7,20.1,11.6-.4.7Zm23.4,25.3-4.5-2.7.4-.7,4.5,2.8Zm30.6-12.6h-.1a3,3,0,0,1-1.1,2.7,3.2,3.2,0,0,1-2.9-.4l-60.5-34.9v-3.8h-1.4v3L220,110.1a10.5,10.5,0,0,1-4.7-8.2V36.7a3.6,3.6,0,0,1,1.3-3.2l.9-.2a3.8,3.8,0,0,1,1.5.5l122.3,70.6c2.4,1.4,4.4,5.2,4.4,8.4Zm7.8,19.5a3.7,3.7,0,0,1-1.1,3.1h-.1a19.4,19.4,0,0,1-5.8,3.5,6.1,6.1,0,0,0,.6-2.8v-4.7l6.4-4Zm0-6.5-6.4,4.1V135.4l6.4-4Zm0-61.2-6.4,4V112.8a11.1,11.1,0,0,0-.9-4.3l6.3-3.9a10.4,10.4,0,0,1,1,4.2Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-3"
            d="M341.3,104.4,219,33.8a3.8,3.8,0,0,0-1.5-.5l-.9.2a3.6,3.6,0,0,0-1.3,3.2v65.2a10.5,10.5,0,0,0,4.7,8.2l59.7,34.4v-3h1.4v3.8l60.5,34.9a3.2,3.2,0,0,0,2.9.4,3,3,0,0,0,1.1-2.7h.1V112.8C345.7,109.6,343.7,105.8,341.3,104.4Zm-60.2,34.1h-1.4v-7.7h1.4Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-2"
            d="M277.9,154.1v4.2a2.8,2.8,0,0,0,1.2,2.3l3.7,2.1h.2v-4.2a2.8,2.8,0,0,0-1.2-2.3l-3.7-2.1Z"
            transform="translate(-0.7 -0.8)"
          />
          <rect
            class="cls-3"
            x="259"
            y="134.4"
            width="0.8"
            height="23.3"
            transform="translate(2.5 296.9) rotate(-60)"
          />
          <rect
            class="cls-3"
            x="301.6"
            y="159"
            width="0.8"
            height="23.3"
            transform="translate(2.5 346) rotate(-60)"
          />
          <rect
            class="cls-3"
            x="312.7"
            y="186.2"
            width="0.8"
            height="5.3"
            transform="translate(-10.4 359.8) rotate(-59.1)"
          />
          <rect class="cls-3" x="291.3" y="196.1" width="0.8" height="5.8" />
          <path
            class="cls-3"
            d="M277.2,152.3a2.4,2.4,0,0,0-1.1,2.2v3.7a4.9,4.9,0,0,0,2.1,4l3.7,2.1a2,2,0,0,0,1.1.3,2,2,0,0,0,1-.2,2.6,2.6,0,0,0,1-2.2v-3.7a4.9,4.9,0,0,0-2.1-4l-3.7-2.1A2.1,2.1,0,0,0,277.2,152.3Zm5.8,6.3v4.2h-.2l-3.7-2.1a2.8,2.8,0,0,1-1.2-2.3v-4.2h.2l3.7,2.1A2.8,2.8,0,0,1,283,158.6Z"
            transform="translate(-0.7 -0.8)"
          />
          <rect class="cls-2" x="279" y="130" width="1.4" height="7.7" />
        </g>
        <g id="Bubble-2" data-name="Bubble">
          <path
            class="cls-2"
            d="M356.9,87.9l-33-19a2.9,2.9,0,0,0-2.7-.3l-6.4,3.9-.2.2h-.2a2.6,2.6,0,0,0-1.3,2.6v25a7.9,7.9,0,0,0,3.6,6.2l5.1,2.9a18.5,18.5,0,0,0,7.9,11.9.9.9,0,0,0,1,0v-.2h.1l5.5-3.4,13.5,7.8a4.1,4.1,0,0,0,1.8.5l1-.2h.4l6.4-3.9a3,3,0,0,0,1.1-2.6V94.3A8.2,8.2,0,0,0,356.9,87.9Zm-6.4,36.6-21.3-12.3h-.7a1,1,0,0,0-.4.5c-.5,2.2.3,4.8,1.2,6.7a17.7,17.7,0,0,1-6.2-10.2,1,1,0,0,0-.5-.8l-5.1-2.9a6.7,6.7,0,0,1-3-5.2v-25a1.7,1.7,0,0,1,.7-1.6c.4-.3,1-.2,1.7.2l33,19.1a6.7,6.7,0,0,1,3,5.2v24.9a1.7,1.7,0,0,1-.7,1.6C351.8,125,351.2,124.9,350.5,124.5Zm2.2-29.6-.4-.6,5.8-3.5.3.6ZM325.7,71l-5.8,3.4-.3-.6,5.7-3.4Zm28.6,49.5-.4-.6,5.7-3.5.4.6Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-3"
            d="M352.2,124.7a1.7,1.7,0,0,0,.7-1.6V98.2a6.7,6.7,0,0,0-3-5.2l-33-19.1c-.7-.4-1.3-.5-1.7-.2a1.7,1.7,0,0,0-.7,1.6v25a6.7,6.7,0,0,0,3,5.2l5.1,2.9a1,1,0,0,1,.5.8,17.7,17.7,0,0,0,6.2,10.2c-.9-1.9-1.7-4.5-1.2-6.7a1,1,0,0,1,.4-.5h.7l21.3,12.3C351.2,124.9,351.8,125,352.2,124.7Zm-13.4-23.3a2.1,2.1,0,0,1,.9-1.9,1.5,1.5,0,0,1,1.7.1l2.5,1.5a4.6,4.6,0,0,1,2,3.7v2.4a2.1,2.1,0,0,1-.9,1.9h-.7l-1-.3-2.5-1.5a4.6,4.6,0,0,1-2-3.7Zm-9.1-5.3a2.1,2.1,0,0,1,.9-1.9,1.5,1.5,0,0,1,1.7.1l2.5,1.5a4.6,4.6,0,0,1,2,3.7v2.3a2.1,2.1,0,0,1-.9,1.9.8.8,0,0,1-.7.2l-1-.3-2.5-1.5a4.6,4.6,0,0,1-2-3.7Zm-9.1-3V90.8a2.1,2.1,0,0,1,.9-1.9,1.5,1.5,0,0,1,1.7.1l2.5,1.5a4.6,4.6,0,0,1,2,3.7v2.3a2.1,2.1,0,0,1-.9,1.9l-.7.2-1-.3-2.5-1.5A4.6,4.6,0,0,1,320.6,93.1Z"
            transform="translate(-0.7 -0.8)"
          />
          <rect
            class="cls-3"
            x="352"
            y="92.5"
            width="6.7"
            height="0.7"
            transform="translate(2.7 197) rotate(-31.3)"
          />
          <rect
            class="cls-3"
            x="353.6"
            y="118.1"
            width="6.7"
            height="0.7"
            transform="translate(-10.3 201.5) rotate(-31.3)"
          />
          <rect
            class="cls-3"
            x="319.3"
            y="72.1"
            width="6.7"
            height="0.7"
            transform="translate(8.5 177) rotate(-31.2)"
          />
          <path
            class="cls-1"
            d="M323.3,95.8l2.5,1.5c.1.1.4.2.5.1a1.1,1.1,0,0,0,.3-.9V94.2a3.3,3.3,0,0,0-1.4-2.7L322.7,90h-.5a1.1,1.1,0,0,0-.3.9v2.3A3.3,3.3,0,0,0,323.3,95.8Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-2"
            d="M322.6,96.8l2.5,1.5,1,.3.7-.2a2.1,2.1,0,0,0,.9-1.9V94.2a4.6,4.6,0,0,0-2-3.7L323.2,89a1.5,1.5,0,0,0-1.7-.1,2.1,2.1,0,0,0-.9,1.9v2.3A4.6,4.6,0,0,0,322.6,96.8Zm-.7-6a1.1,1.1,0,0,1,.3-.9h.5l2.5,1.5a3.3,3.3,0,0,1,1.4,2.7v2.3a1.1,1.1,0,0,1-.3.9c-.1.1-.4,0-.5-.1l-2.5-1.5a3.3,3.3,0,0,1-1.4-2.7Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-1"
            d="M332.3,101.1l2.5,1.5c.1.1.4.2.5.1a1.1,1.1,0,0,0,.3-.9V99.5a3.3,3.3,0,0,0-1.4-2.7l-2.5-1.5c-.1-.1-.4-.2-.5-.1a1.1,1.1,0,0,0-.3.9v2.3A3.3,3.3,0,0,0,332.3,101.1Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-2"
            d="M331.7,102.1l2.5,1.5,1,.3a.8.8,0,0,0,.7-.2,2.1,2.1,0,0,0,.9-1.9V99.5a4.6,4.6,0,0,0-2-3.7l-2.5-1.5a1.5,1.5,0,0,0-1.7-.1,2.1,2.1,0,0,0-.9,1.9v2.3A4.6,4.6,0,0,0,331.7,102.1Zm-.8-6a1.1,1.1,0,0,1,.3-.9c.1-.1.4,0,.5.1l2.5,1.5a3.3,3.3,0,0,1,1.4,2.7v2.3a1.1,1.1,0,0,1-.3.9c-.1.1-.4,0-.5-.1l-2.5-1.5a3.3,3.3,0,0,1-1.4-2.7Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-1"
            d="M341.4,106.4l2.5,1.5c.1.1.4.2.5.1a1.1,1.1,0,0,0,.3-.9v-2.3a3.3,3.3,0,0,0-1.4-2.7l-2.5-1.5c-.1-.1-.4-.2-.5-.1a1.1,1.1,0,0,0-.3.9v2.3A3.3,3.3,0,0,0,341.4,106.4Z"
            transform="translate(-0.7 -0.8)"
          />
          <path
            class="cls-2"
            d="M340.8,107.4l2.5,1.5,1,.3h.7a2.1,2.1,0,0,0,.9-1.9v-2.4a4.6,4.6,0,0,0-2-3.7l-2.5-1.5a1.5,1.5,0,0,0-1.7-.1,2.1,2.1,0,0,0-.9,1.9v2.3A4.6,4.6,0,0,0,340.8,107.4Zm-.8-6a1.1,1.1,0,0,1,.3-.9c.1-.1.4,0,.5.1l2.5,1.5a3.3,3.3,0,0,1,1.4,2.7v2.3a1.1,1.1,0,0,1-.3.9c-.1.1-.4,0-.5-.1l-2.5-1.5a3.3,3.3,0,0,1-1.4-2.7Z"
            transform="translate(-0.7 -0.8)"
          />
          <rect
            class="cls-2"
            x="361.3"
            y="84.9"
            width="5.7"
            height="1.4"
            transform="translate(32.9 259.9) rotate(-41.1)"
          />
          <rect
            class="cls-2"
            x="356"
            y="81"
            width="5.7"
            height="1.4"
            transform="translate(145.9 381.5) rotate(-67.6)"
          />
          <rect
            class="cls-2"
            x="364.5"
            y="90.2"
            width="5.7"
            height="1.4"
            transform="translate(-11.7 95.2) rotate(-14.7)"
          />
        </g>
        <g id="B">
          <g id="Group_5" data-name="Group 5">
            <g id="Group_6" data-name="Group 6">
              <g id="Vector_2" data-name="Vector 2">
                <path
                  class="cls-1"
                  d="M279.6,119.2v-8.5l4.4,2.5h.2a9.9,9.9,0,0,1,3.1,3,7.9,7.9,0,0,1,.9,3.8c0,1.4-.3,2.2-1.1,2.4a4.4,4.4,0,0,1-3.2-1Zm.2-13.9V97.1l2.8,1.6a10.3,10.3,0,0,1,3.6,3.2,5,5,0,0,1,1.1,3.7c0,1.3-.5,2.1-1.3,2.2s-2-.1-3.7-1.1Zm2.8-12.4-9.7-5.7-.2,34,11.3,6.5c3.6,2,6.4,2.8,8.3,2.2s3-2.6,3-5.9a16.6,16.6,0,0,0-1.2-5.5,15.2,15.2,0,0,0-4-5,2.8,2.8,0,0,0,3-1.1,6.9,6.9,0,0,0,1-3.8,14.8,14.8,0,0,0-3-8.8A34,34,0,0,0,282.6,92.9Z"
                  transform="translate(-0.7 -0.8)"
                />
                <g class="cls-7">
                  <path
                    class="cls-6"
                    d="M279.6,119.2v-8.5l4.4,2.5h.2a9.9,9.9,0,0,1,3.1,3,7.9,7.9,0,0,1,.9,3.8c0,1.4-.3,2.2-1.1,2.4a4.4,4.4,0,0,1-3.2-1Zm.2-13.9V97.1l2.8,1.6a10.3,10.3,0,0,1,3.6,3.2,5,5,0,0,1,1.1,3.7c0,1.3-.5,2.1-1.3,2.2s-2-.1-3.7-1.1Zm2.8-12.4-9.7-5.7-.2,34,11.3,6.5c3.6,2,6.4,2.8,8.3,2.2s3-2.6,3-5.9a16.6,16.6,0,0,0-1.2-5.5,15.2,15.2,0,0,0-4-5,2.8,2.8,0,0,0,3-1.1,6.9,6.9,0,0,0,1-3.8,14.8,14.8,0,0,0-3-8.8A34,34,0,0,0,282.6,92.9Z"
                    transform="translate(-0.7 -0.8)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <line id="Divider" class="cls-8" x1="195.2" x2="195.2" y2="227.6" />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    splitTesting() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: `#milestone-splittesting`,
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1,
            ease: "back",
          },
        })
        .add("split")
        .from(
          `#Magnifying_Glass`,
          {
            opacity: 0.5,
            rotation: 180,
            scale: 0,
            transformOrigin: "50% 50%",
          },
          "split"
        )
        .from(
          `#Screen`,
          {
            opacity: 0.5,
            rotation: -30,
            transformOrigin: "100% 0%",
            ease: "back.out(2)",
          },
          "split"
        )
        .from(
          `#Screen-2`,
          {
            opacity: 0.5,
            rotation: 30,
            transformOrigin: "0% 0%",
            ease: "back.out(2)",
          },
          "split"
        )
        .from(
          "#A, #B",
          {
            opacity: 0,
            ease: "sine",
          },
          "split+=0.5"
        )
        .from(
          "#Circle_3, #Circle_2, #Circle_1-2, #Square_1, #Square_2",
          {
            opacity: 0,
            stagger: 0.2,
            ease: "sine",
          },
          "split+=1"
        );
    },
  },
  mounted() {
    this.splitTesting();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #fff;
}

.cls-2 {
  fill: #0e1e25;
}

.cls-3 {
  fill: #ffad43;
}

.cls-4,
.cls-6,
.cls-8 {
  fill: none;
}

.cls-5 {
  mask: url(#mask);
}

.cls-6,
.cls-8 {
  stroke: #0e1e25;
}

.cls-6 {
  stroke-width: 4px;
}

.cls-7 {
  mask: url(#mask-2);
}

.cls-8 {
  stroke-width: 3px;
}
</style>
